var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ blocked: _vm.isSpinnerActive },attrs:{"id":"app"}},[(_vm.isSpinnerActive)?_c('hollow-dots-spinner',{attrs:{"animation-duration":1000,"size":60,"color":'#ff1d5e'}}):_vm._e(),_vm._v(" "+_vm._s(_vm.spinnerMessage)+" "),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }